import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from "recompose";

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';

import EnhancedTablePipedrive from './EnhancedTablePipedrive';
import CustomizedSnackbars from '../Common/CustomizedSnackbars';
import Progress from '../Common/Progress';
import { pipedriveActions, projectActions } from '../../_actions';

const styles = theme => ({
    Content: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    button: {
        margin: theme.spacing.unit,
    },
    paper: {
        position: 'absolute',
        width: '90%',
        [theme.breakpoints.down('sm')]: {
            overflow: 'scroll',
        },
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
    },
    textField: {
        margin: theme.spacing.unit,
        flexBasis: 200,
    },
    margin: {
        margin: theme.spacing.unit,
    },
});

class ImportPipedrive extends Component {
    constructor(props) {
        super(props);
        this.state = {
            AddData: [],
            snackbarOpen: false,
            pipedriveData: [],
            saveBtnDisabled: true,
            openProgress: false,
        };

        this.handleAddClick = this.handleAddClick.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    componentDidMount() {
        //this.props.dispatch(pipedriveActions.getAll());
    }

    handleClose = () => {
        this.setState({
            snackbarOpen: false,
            saveBtnDisabled: true,
            openProgress: false
        })

        this.props.close();
    };

    handleAddClick = (AddData) => {
        this.setState({
            AddData: AddData,
            snackbarOpen: true,
            saveBtnDisabled: false,
        })
    }

    handleSave = () => {
        this.setState({
            openProgress: true
        })

        var inputData = {
            'AddData': this.state.AddData,
            'CreatedUserId': this.props.user.id,
        };

        const insertData = async () => {
            try {
                await this.props.dispatch(pipedriveActions.pendingToActive(inputData));
                await this.props.dispatch(projectActions.getAll());
                await this.handleClose();
                await this.props.dispatch(pipedriveActions.getAll());
            } catch (e) {
                console.error("Problem", e)
            }
        }

        insertData();
    }

    handleSnackBarClose = () => {
        this.setState({
            snackbarOpen: false
        })
    }

    render() {
        const { classes, pipedrive } = this.props;
        const snackbarMessage = 'Pipedrive deals data (ID: ' + this.state.AddData.map(option => ' ' + option) + ') will be saved to HunterGame database after Save button pressed';

        return (
            <div>
                <Progress openProgress={this.state.openProgress} />

                <CustomizedSnackbars
                    open={this.state.snackbarOpen}
                    close={this.handleSnackBarClose}
                    snackbarMessage={snackbarMessage}
                />

                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.props.open}
                    onClose={this.handleClose}
                >
                    <div style={getModalStyle()} className={classes.paper}>
                        <Typography id="modal-title" style={{ fontSize: 40 }}>
                            Import Pipedrive Deals
                        </Typography>

                        <EnhancedTablePipedrive
                            handleAddClick={this.handleAddClick}
                            data={pipedrive.items ? pipedrive.items : []}
                        />

                        <div style={{ marginTop: '40px' }} />
                        <Button color="secondary" variant="outlined" className={classes.button} onClick={this.handleSave} disabled={this.state.saveBtnDisabled} >
                            Save
                        </Button>
                        <Button variant="outlined" className={classes.button} onClick={this.handleClose}>
                            Cancel
                        </Button>
                    </div>
                </Modal>
            </div>
        )
    }
}

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

function mapStateToProps(state) {
    const { user } = state.authentication;
    const { pipedrive } = state;

    return {
        user,
        pipedrive,
    };
}

ImportPipedrive.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default compose(connect(mapStateToProps), withStyles(styles))(ImportPipedrive);


// WEBPACK FOOTER //
// ./src/components/Projects/ImportPipedrive.js